export const slotsIntlIds = {
  seo: {
    pages: {
      slotsList: {
        title: 'slotsIntlIds.seo.pages.slotsList.title',
        description: 'slotsIntlIds.seo.pages.slotsList.description',
      },
      slotsByHubList: {
        title: 'slotsIntlIds.seo.pages.slotsByHubList.title',
        description: 'slotsIntlIds.seo.pages.slotsByHubList.description',
      },
    },
  },

  slotsList: {
    header: {
      title: 'slotsIntlIds.slotsList.header.title',

      createSlotsButton: {
        label: 'slotsIntlIds.slotsList.header.createSlotsButton.label',
      },
      divulgateSlotsButton: {
        label: 'slotsIntlIds.slotsList.header.divulgateSlotsButton.label',
      },
    },

    table: {
      cell: {
        header: {
          hubAlias: 'slotsIntlIds.slotsList.table.cell.header.hubAlias',
          totalSlots: 'slotsIntlIds.slotsList.table.cell.header.totalSlots',
          bookedSlots: 'slotsIntlIds.slotsList.table.cell.header.bookedSlots',
          availableSlots:
            'slotsIntlIds.slotsList.table.cell.header.availableSlots',
          shifts: 'slotsIntlIds.slotsList.table.cell.header.shifts',
          dates: 'slotsIntlIds.slotsList.table.cell.header.dates',
        },

        body: {
          totalSlots: 'slotsIntlIds.slotsList.table.cell.body.totalSlots',
          bookedSlots: 'slotsIntlIds.slotsList.table.cell.body.bookedSlots',
          availableSlots: {
            total:
              'slotsIntlIds.slotsList.table.cell.body.availableSlots.total',
            byStatus:
              'slotsIntlIds.slotsList.table.cell.body.availableSlots.byStatus',
          },
          shifts: 'slotsIntlIds.slotsList.table.cell.body.shifts',
          dates: 'slotsIntlIds.slotsList.table.cell.body.dates',
        },
      },
    },
  },

  slotsByHubList: {
    header: {
      title: 'slotsIntlIds.slotsByHubList.header.title',
      breadcrumb: {
        allSlots: 'slotsIntlIds.slotsByHubList.header.breadcrumb.allSlots',
        slotsFromHub:
          'slotsIntlIds.slotsByHubList.header.breadcrumb.slotsFromHub',
      },
    },

    searchInput: {
      type: 'slotsIntlIds.slotsByHubList.searchInput.type',
      label: 'slotsIntlIds.slotsByHubList.searchInput.label',
      placeholder: 'slotsIntlIds.slotsByHubList.searchInput.placeholder',
      submitButton: {
        label: 'slotsIntlIds.slotsByHubList.searchInput.submitButton.label',
      },
    },

    assignedSlotsTab: {
      label: 'slotsIntlIds.slotsByHubList.assignedSlotsTab.label',
    },
    hubShiftsTab: {
      label: 'slotsIntlIds.slotsByHubList.hubShiftsTab.label',
    },

    searchSlotsButton: {
      label: 'slotsIntlIds.slotsByHubList.searchSlotsButton.label',
    },
  },

  assignedSlotsByHubList: {
    table: {
      cell: {
        header: {
          date: 'slotsIntlIds.assignedSlotsByHubList.table.cell.header.date',
          shift: 'slotsIntlIds.assignedSlotsByHubList.table.cell.header.shift',
          rider: 'slotsIntlIds.assignedSlotsByHubList.table.cell.header.rider',
          assignedAt:
            'slotsIntlIds.assignedSlotsByHubList.table.cell.header.assignedAt',
          originOfAssign:
            'slotsIntlIds.assignedSlotsByHubList.table.cell.header.originOfAssign',
          cancelSlot:
            'slotsIntlIds.assignedSlotsByHubList.table.cell.header.cancelSlot',
        },

        body: {
          shift: 'slotsIntlIds.assignedSlotsByHubList.table.cell.body.shift',
          rider: 'slotsIntlIds.assignedSlotsByHubList.table.cell.body.rider',
        },
      },
    },
  },

  slotOriginAssignmentTag: {
    assignedByRaioWeb: {
      label: 'slotsIntlIds.slotOriginAssignmentTag.assignedByRaioWeb.label',
    },
    assignedByRaioApp: {
      label: 'slotsIntlIds.slotOriginAssignmentTag.assignedByRaioApp.label',
    },
  },

  createSlots: {
    drawer: {
      title: 'slotsIntlIds.createSlots.drawer.title',
      closeDrawerButton: {
        label: 'slotsIntlIds.createSlots.drawer.closeDrawerButton.label',
      },
      content: {
        tabs: {
          importSlots: {
            label:
              'slotsIntlIds.createSlots.drawer.content.tabs.importSlots.label',
          },
          createUnitarySlot: {
            label:
              'slotsIntlIds.createSlots.drawer.content.tabs.createUnitarySlot.label',
          },
        },
        tabPanels: {
          importSlots: {
            title:
              'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.title',
            description:
              'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.description',
            footer: {
              confirmImportSlotsButton: {
                label:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.footer.confirmImportSlotsButton.label',
              },
              cancelImportSlotsButton: {
                label:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.footer.cancelImportSlotsButton.label',
              },
            },

            onImportSlots: {
              success: {
                title:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots.success.title',
                description:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots.success.description',
              },
              error: {
                title:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots.error.title',
                description:
                  'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots.error.description',
              },
            },
          },
        },
      },
    },
  },

  divulgateSlots: {
    drawer: {
      title: 'slotsIntlIds.divulgateSlots.drawer.title',
      closeDrawerButton: {
        label: 'slotsIntlIds.divulgateSlots.drawer.closeDrawerButton.label',
      },
      content: {
        tabs: {
          importDivulgationRules: {
            label:
              'slotsIntlIds.divulgateSlots.drawer.content.tabs.importDivulgationRules.label',
          },
          divulgateSlots: {
            label:
              'slotsIntlIds.divulgateSlots.drawer.content.tabs.divulgateSlots.label',
          },
        },
        tabPanels: {
          importDivulgationRules: {
            title:
              'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.title',
            description:
              'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.description',

            footer: {
              confirmImportDivulgationRulesButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.footer.confirmImportDivulgationRulesButton.label',
              },
              cancelImportDivulgationRulesButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.footer.cancelImportDivulgationRulesButton.label',
              },
            },

            onImportDivulgationRules: {
              success: {
                title:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.onImportDivulgationRules.success.title',
                description:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.onImportDivulgationRules.success.description',
              },
              error: {
                title:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.onImportDivulgationRules.error.title',
                description:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules.onImportDivulgationRules.error.description',
              },
            },
          },
          divulgateSlots: {
            title:
              'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.title',
            description:
              'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.description',
            divulgationRulesStatus: {
              noRulesImported: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesStatus.noRulesImported.label',
              },
              rulesBeingImported: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesStatus.rulesBeingImported.label',
              },
              lastRulesImportedAt: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesStatus.lastRulesImportedAt.label',
              },
            },
            divulgationRulesSummary: {
              title:
                'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.title',
              slotsDates: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.slotsDates.label',
                value:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.slotsDates.value',
              },
              totalDates: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalDates.label',
                value:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalDates.value',
              },
              totalSlots: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalSlots.label',
                value:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalSlots.value',
              },
              totalHubs: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalHubs.label',
                value:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.totalHubs.value',
              },
              shifts: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.shifts.label',
              },
              modalities: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.modalities.label',
              },
              medals: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.divulgationRulesSummary.medals.label',
              },
            },
            footer: {
              confirmDivulgateSlotsButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.footer.confirmDivulgateSlotsButton.label',
              },
              cancelDivulgateSlotsButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.footer.cancelDivulgateSlotsButton.label',
              },
            },

            confirmDivulgatePlanningModal: {
              title:
                'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.confirmDivulgatePlanningModal.title',
              description:
                'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.confirmDivulgatePlanningModal.description',
              confirmAndDivulgateButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.confirmDivulgatePlanningModal.confirmAndDivulgateButton.label',
              },
              cancelButton: {
                label:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.confirmDivulgatePlanningModal.cancelButton.label',
              },
            },

            onDivulgatePlanning: {
              success: {
                title:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.onDivulgatePlanning.success.title',
                description:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.onDivulgatePlanning.success.description',
              },
              error: {
                title:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.onDivulgatePlanning.error.title',
                description:
                  'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.onDivulgatePlanning.error.description',
              },
            },

            emptyDivulgationPlanning: {
              title:
                'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.emptyDivulgationPlanning.title',
              description:
                'slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.emptyDivulgationPlanning.description',
            },
          },
        },
      },
    },
  },

  confirmImportSlotsOrDivulgationRulesModal: {
    title: 'slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.title',
    description:
      'slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.description',
    confirmAndImportButton: {
      label:
        'slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.confirmAndImportButton.label',
    },
    cancelButton: {
      label:
        'slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.cancelButton.label',
    },
  },

  cancelImportOrDivulgateSlotsModal: {
    title: 'slotsIntlIds.cancelImportOrDivulgateSlotsModal.title',
    description: 'slotsIntlIds.cancelImportOrDivulgateSlotsModal.description',
    stayAndContinueButton: {
      label:
        'slotsIntlIds.cancelImportOrDivulgateSlotsModal.stayAndContinueButton.label',
    },
    leaveButton: {
      label: 'slotsIntlIds.cancelImportOrDivulgateSlotsModal.leaveButton.label',
    },
  },

  divulgationSteps: {
    label:
      'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.label',
    chevron: {
      label:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.chevron.label',
    },
    createSlot: {
      label:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.createSlot.label',
      description:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.createSlot.description',
    },
    importRules: {
      label:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.importRules.label',
      description:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.importRules.description',
    },
    divulgateSlots: {
      label:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.divulgateSlots.label',
      description:
        'slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.steps.divulgateSlots.description',
    },
  },

  cancelRiderBookedSlotModal: {
    trigger: {
      openModalButton: {
        label:
          'slotsIntlIds.cancelRiderBookedSlotModal.trigger.openModalButton.label',
      },
    },
    header: {
      title: 'slotsIntlIds.cancelRiderBookedSlotModal.header.title',
      closeIconButton: {
        label:
          'slotsIntlIds.cancelRiderBookedSlotModal.header.closeIconButton.label',
      },
    },
    body: {
      description: 'slotsIntlIds.cancelRiderBookedSlotModal.body.description',
    },
    footer: {
      cancelButton: {
        label:
          'slotsIntlIds.cancelRiderBookedSlotModal.footer.cancelButton.label',
      },
      confirmAndCancelButton: {
        label:
          'slotsIntlIds.cancelRiderBookedSlotModal.footer.confirmAndCancelButton.label',
      },
    },

    toasts: {
      onSuccess: {
        title: 'slotsIntlIds.cancelRiderBookedSlotModal.toasts.onSuccess.title',
        description:
          'slotsIntlIds.cancelRiderBookedSlotModal.toasts.onSuccess.description',
      },
      onError: {
        title: 'slotsIntlIds.cancelRiderBookedSlotModal.toasts.onError.title',
        description:
          'slotsIntlIds.cancelRiderBookedSlotModal.toasts.onError.description',
      },
    },
  },
};
